import { FoundationType } from "./v1";

export const foundationTypeOptions = Object.entries(FoundationType)
	.filter(([, value]) => {
		return isNaN(Number(value));
	})
	.map(([value, label]) => {
		return { value, label };
	});
